import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardListResultCount } from 'src/app/models/air/list/dashboard-list-result-counts';
import { ListService } from 'src/app/services/list/list.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { TranslateService } from '@ngx-translate/core';
import { ChangeLanguageService } from 'src/app/services/change-language.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TrackingeComponent } from '../tracking/tracking/tracking.component';
import { NotificationsComponent } from '../user/notifications/notifications.component';
import { NotificationsService } from 'src/app/services/notifications/notifications.service';
import { NotificationsModel } from 'src/app/models/notifications.model';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { ClickHistorySubject } from 'src/app/events/click-history.events';
import { UserModel } from 'src/app/models/auth/user.model';
import { UserService } from 'src/app/services/user/user.service';
import { SearchDetailDialog } from 'src/app/components/search-detail-dialog/search-detail-dialog.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit {
    user: UserModel = null;
    notificationsdialogRef: DynamicDialogRef;
    dashboardListResultCountsDTO: DashboardListResultCount = new DashboardListResultCount();
    operationType = [];
    @ViewChild('overlayPanel') overlayPanel!: OverlayPanel;
    showSearch: boolean = false;
    trackingDialogRef: DynamicDialogRef;
    lastNotification: NotificationsModel = null;
    searchDetailDialogRef: DynamicDialogRef;

    constructor(public router: Router, private listService: ListService, public appMain: AppMainComponent, private translateService: TranslateService,
        private changeLanguageService: ChangeLanguageService, private dialogService: DialogService, private notificationsService: NotificationsService,
        private userService: UserService) { }

    async ngOnInit() {

        // son bildirim get ile getirilecek. şimdilik aşağıdaki gibi...
        const readedNotification = await this.notificationsService.getWithOffsetAndReadTime(true, true ? "0" : String(0), []).toPromise();
        if (readedNotification && readedNotification.length > 0) this.lastNotification = readedNotification[0];

        this.dashboardListResultCountsDTO = await this.listService.getListCount().toPromise();

        this.getSearchContainerOptions();

        this.changeLanguageService.languageChanged.subscribe((lang) => {
            this.getSearchContainerOptions();
        });
        this.user = await this.userService.user().toPromise();

    }

    get isUserApproved(): Boolean {
        return this.user?.status === 'AP';
    }

    navitage(path, params: any = {}) {
        this.router.navigate([`/${path}`], params)
    }

    ngAfterViewInit(): void {
        if (window.innerWidth > 768) {
            this.appMain.appendScriptSrc('/assets/js/zoho.js')
        }
    }

    protected readonly location = location;

    async getSearchContainerOptions() {
        const select = await this.translateService.get("selectEmpty").toPromise();
        const airWay = await this.translateService.get("airWay").toPromise();
        const seaWay = await this.translateService.get("seaWay").toPromise();
        const truckWay = await this.translateService.get("truckWay").toPromise();
        this.operationType = [{ name: seaWay, code: 'SEA' }, { name: airWay, code: 'AIR' }, { name: truckWay, code: 'TRUCK', disabled: true }];
    }

    performSearch(event: any) {
        if (!event) return;
        this.resetView();
        this.trackingDialogRef = this.dialogService.open(TrackingeComponent, { header: "", width: '100%', height: '100vh', contentStyle: { "overflow": "auto" }, modal: true, closable: true, data: { searchText: event.searchText, "operation": { code: event.operation } } });

    }

    resetView() {
        if (this.overlayPanel) this.overlayPanel.hide();
        this.showSearch = false;
    }

    showNotificationsDialog() {
        this.notificationsdialogRef = this.dialogService.open(NotificationsComponent,
            { header: null, showHeader: false, modal: true, width: '800px', height: '800px', closable: false, data: {} });
    }

    onClickSearchRate(url: string, operation: string) {
        const model = new SearchLogClickHistoryModel();
        model.productName = 'main-rates'
        model.viewType = operation;
        ClickHistorySubject.next(model);

        this.navitage(url, {})

    }

    onClickWopi() {
        const email = 'wopi@weld-int.com';
        const subject = '';
        const body = '';
        window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        const model = new SearchLogClickHistoryModel();
        model.viewType = "WOPI";
        model.productName = 'main-left';
        ClickHistorySubject.next(model);

    }


    onClickDashboardCard(url: string, params: any = {}, viewType: string) {
        const model = new SearchLogClickHistoryModel();
        model.viewType = viewType;
        model.productName = 'main-dashboard'
        model.info = url
        ClickHistorySubject.next(model);

        this.navitage(url, params)

    }

    async showNotification(model: NotificationsModel) {

        if (['RZ', 'EX', 'IE', 'NP'].includes(model.subStatus)) return;

        await this.notificationsService.readNotifications([model.id]).toPromise();


        if (['SC', 'AP'].includes(model.subStatus)) {
            this.trackingDialogRef = this.dialogService.open(TrackingeComponent, {
                header: model.relatedNo, width: '100%', height: '100vh', contentStyle: { "overflow": "auto" }, modal: true, closable: true,
                data: {
                    shipmentNo: model.relatedNo,
                    operation: { code: model.operationType }
                }
            });
        } else {
            this.searchDetailDialogRef = this.dialogService.open(SearchDetailDialog, { header: null, showHeader: false, modal: true, width: '90vw', height: '100vh', closable: false, data: { operation: model.operationType, id: model.relatedId, viewType: 'card' } });
        }

        const clickHistoryModel = new SearchLogClickHistoryModel();
        clickHistoryModel.viewType = "notification";
        clickHistoryModel.productName = model.relatedNo; 
        ClickHistorySubject.next(clickHistoryModel)

    }

}
